export const formatUnrecognizedTableData = (data) => {
  return data.map((item, index) => {
    return {
      ...item,
      key: `unrecognized_table_item_${index}`,
    };
  });
};
